import React from 'react';
import Image, { ImageProps } from 'components/commercetools-ui/atoms/image';
import Link from 'components/commercetools-ui/atoms/link';
import { Reference } from 'types/reference';

interface ImageLinkProps {
  media?: ImageProps;
  link?: Reference;
  className?: string;
  marginRight?: string;
  title?: string;
  ffid?: string;
  hasSecondary?: boolean;
  imageClassNames?: string;
  onClick?: () => void;
  cropType?: 'limit' | 'scale';
  unoptimized?: boolean;
}

const ImageLink: React.FC<ImageLinkProps> = ({
  media,
  link,
  className = '',
  marginRight = '0px',
  ffid,
  hasSecondary,
  imageClassNames = '',
  onClick,
  cropType,
  unoptimized = false,
}) => {
  if (!media?.media?.width || !media?.media?.height) return null;

  const width = hasSecondary ? '50%' : '100%';
  const formattedffids = ffid?.includes(' ') ? ffid?.toLowerCase().replace(/\s+/g, '-') : ffid?.toLowerCase();
  const handleKeyDown = (e: React.KeyboardEvent) => {
    if (e.key === ' ' || e.key === 'Spacebar') {
      e.preventDefault();
      onClick?.();
    }
  };
  return (
    <Link
      aria-label="Go to Fujifilm and Google Photos platform home"
      className={className}
      style={{
        width: width,
        height: '100%',
        marginRight: hasSecondary ? marginRight : '0px',
      }}
      link={link}
      onKeyDown={handleKeyDown}
      onClick={onClick}
      data-ffid={`lnk-${formattedffids}`}
    >
      <Image
        media={media.media}
        alt={media.title || media.alt || ''}
        data-testid="image"
        data-ffid={`img-${formattedffids}`}
        className={imageClassNames}
        style={{
          width: '100%',
          height: '100%',
        }}
        cropType={cropType}
        unoptimized={unoptimized}
      />
    </Link>
  );
};

export default ImageLink;
